import * as THREE from 'three'

export function serialize(obj: any): any {
    if (obj instanceof THREE.Quaternion) {
        return { x: obj.x, y: obj.y, z: obj.z, w: obj.w, __isQuaternion: true };
    } else if (obj instanceof THREE.Vector3) {
        return { x: obj.x, y: obj.y, z: obj.z, __isVector3: true };
    } else if (Array.isArray(obj)) {
        return obj.map(serialize);
    } else if (typeof obj === "object" && obj !== null) {
        return Object.fromEntries(
            Object.entries(obj).map(([key, value]) => [key, serialize(value)])
        );
    }
    return obj;
}

export function deserialize(obj: any): any {
    if (obj && typeof obj === "object") {
        if (obj.__isQuaternion) {
            const quat = new THREE.Quaternion(obj.x, obj.y, obj.z, obj.w);
            Object.setPrototypeOf(quat, THREE.Quaternion.prototype)
            return quat
        } else if (obj.__isVector3) {
            const vec = new THREE.Vector3(obj.x, obj.y, obj.z);
            Object.setPrototypeOf(vec, THREE.Vector3.prototype)
            return vec
        } else if (Array.isArray(obj)) {
            return obj.map(deserialize);
        } else {
            return Object.fromEntries(
                Object.entries(obj).map(([key, value]) => [key, deserialize(value)])
            );
        }
    }
    return obj;
}
